import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import InAppNotificationActionMetadata from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import InAppNotificationActionDetail from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class InAppNotificationActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(InAppNotificationActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
InAppNotificationActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(InAppNotificationActionMetadata).isRequired,
  actionLabel: PropTypes.node,
  flowObjectTypeId: ObjectTypeIdType
};
export default InAppNotificationActionHistoryCard;